import { t } from "i18next";
import { Plus } from "lucide-react";
import { useState } from "react";
import { ArtmatchIdentifyArtworkJourney } from "../artmatch/ArtmatchIdentifyArtworkJourney";
import { Button } from "../ui/button";
import { AddArtworkChoiceDialog } from "./AddArtworkChoiceDialog";
import NewArtworkDialog from "./NewArtworkDialog";

export const NewArtworkJourney = ({
  isArtmatchEnabled,
}: {
  isArtmatchEnabled: boolean;
}) => {
  const [jouneyDialogOpen, setJourneyDialogOpen] = useState<
    "choose" | "artmatch" | "new"
  >();

  return (
    <>
      <Button
        className="flex items-center gap-2"
        onClick={() =>
          setJourneyDialogOpen(isArtmatchEnabled ? "choose" : "new")
        }
      >
        <Plus size={16} />
        {t("newArtwork")}
      </Button>
      <NewArtworkDialog
        open={jouneyDialogOpen === "new"}
        onOpenChange={(open) => setJourneyDialogOpen(open ? "new" : undefined)}
      />
      <AddArtworkChoiceDialog
        open={jouneyDialogOpen === "choose"}
        onOpenChange={(open) =>
          setJourneyDialogOpen(open ? "choose" : undefined)
        }
        onChoseUseArtmatch={() => setJourneyDialogOpen("artmatch")}
        onChoseUseNewArtwork={() => setJourneyDialogOpen("new")}
      />
      <ArtmatchIdentifyArtworkJourney
        open={jouneyDialogOpen === "artmatch"}
        onOpenChange={(open) =>
          setJourneyDialogOpen(open ? "artmatch" : undefined)
        }
      />
    </>
  );
};
